import { isAnimationControls } from "../../animation/utils/is-animation-controls";
import { isVariantLabel } from "./is-variant-label";
import { variantProps } from "./variant-props";
export function isControllingVariants(props) {
    return (isAnimationControls(props.animate) ||
        variantProps.some((name) => isVariantLabel(props[name])));
}
export function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}
//# sourceMappingURL=is-controlling-variants.js.map